<template>
  <div
    class="sg-select-dropdown"
    :class="[{ 'is-multiple': isMultiple }, popperClass]"
    :style="{ [isFitInputWidth || scrollwidth ? 'width' : 'minWidth']: scrollwidth ? `${scrollwidth}px` : minWidth }"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  onMounted,
  onBeforeUnmount,
  inject,
  ref,
} from 'vue'
import {
  addResizeListener,
  removeResizeListener,
} from '@sgui-plus/utils/resize-event'
import { SelectContextKey } from './token'
import type { ResizableElement } from '@sgui-plus/utils/resize-event'

export default defineComponent({
  name: 'SgSelectDropdown',

  componentName: 'SgSelectDropdown',

  setup() {
    const select = inject(SelectContextKey)!
    // computed
    const popperClass = computed(() => select.props.popperClass)
    const isMultiple = computed(() => select.props.multiple)
    const isFitInputWidth = computed(() => select.props.dropWidthLinked)
    const minWidth = ref('')
    const scrollwidth = computed(() => select.props.scrollwidth)
    function updateMinWidth() {

      minWidth.value = `${
        select.selectWrapper?.getBoundingClientRect().width
      }px`
    }

    onMounted(() => {
      // TODO: updatePopper
      // popper.value.update()
      updateMinWidth()
      addResizeListener(
        select.selectWrapper as ResizableElement,
        updateMinWidth
      )
    })

    onBeforeUnmount(() => {
      removeResizeListener(
        select.selectWrapper as ResizableElement,
        updateMinWidth
      )
    })

    return {
      minWidth,
      scrollwidth,
      popperClass,
      isMultiple,
      isFitInputWidth,
    }
  },
})
</script>
